import { MDBContainer } from "mdb-react-ui-kit";
import { Avatar, message } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import { Modal, Box, IconButton } from "@mui/material";


import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "../PassportDetails.css";
import "datatables.net";

import { SendPostRequest } from "../ApiRequest";

function ActualHotalReturnModal({ heading, open, setOpen, sendDataToModal }) {
  const handleClose = () => {
    setOpen(false);
  };
  const [modalData, setModalData] = useState([]);

  // implementing using single object
  const [mainState, setMainState] = useState({
    refund_quantity: "",
    Remarks:"",
  

  });

  const [loading, setLoading] = useState(false);

  

  // Add error states for other fields

  const [errors, setErrors] = useState({
    refund_quantity: "",
    Remarks:"",
   
  });

  const [expandedRows, setExpandedRows] = useState([]);
  const [selectedPligrams, setSelectedPligrams] = useState([]);

  const toggleExpansion = (index) => {
    const newExpandedRows = [...expandedRows];
    newExpandedRows[index] = !newExpandedRows[index];
    setExpandedRows(newExpandedRows);
  };

  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };
     const [tableData3, setTableData3] = useState([]);
  

  const fetchData3 = async () => {
    const endpoint = "api/umrah/activity/show";

    try {
      setLoading(true);
      const response = await SendPostRequest(endpoint, sendDataToModal);
      console.log(response.data.records);
      setLoading(false);

      if (response && response.data && response.data.records) {
        setModalData(response.data);
        setTableData3(response.data.records);

      
      
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData3();
  }, [sendDataToModal]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    p: 4,
    width: "97%",
  };





  // api will be added here

  const SubmitingFunction = (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!mainState.refund_quantity.trim()) {
      newErrors.refund_quantity = "refund quantity required";
    }

       if (!mainState.Remarks.trim()) {
      newErrors.Remarks = "refund quantity required";
    }




 
    setErrors(newErrors);

    // If there are no errors, proceed
    if (Object.keys(newErrors).length === 0) {
      console.log("Form is valid ✅", mainState);
      // Submit logic here
    }
  };

  // reset function
  const resetFormStates = () => {
    // Reset mainState in one go
    setMainState({
      refund_quantity: "",
      Remarks:""
     
    });

    // Reset all error states

    setErrors({
      refund_quantity: "",
      Remarks:"",
    
    });
  };



  return (
    <>
      <Modal
        open={open}
        key={open ? "modal-open" : "modal-closed"}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
            resetFormStates();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...style,
            maxHeight: "90vh", // Limit height to viewport
            overflow: "auto", // Hide overflow from parent
            display: "flex",
            flexDirection: "column",
          }}
        >
          <IconButton
            onClick={() => {
              handleClose();
              resetFormStates();
            }}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <div>
            <MDBContainer breakpoint=" p-4">
              <div className="main-wrapper">
                <div>
                  <h1 className="main-hading"> Retrun Voucher</h1>

         
                    <hr />
                  <form>
                    <h2 style={{ marginTop: "20px" }}>
                  Voucher's Detail
                    </h2>

                    {/* first cash  */}

{/* api fetched Data  */}
<>

                    <div className="mt-3">

                     <h3 className="d-inline">
                        Agent :-{"  "}
                     </h3>
                   


                    </div>

<div className="mt-3">
  <h3 className="d-inline">Arrival Date :-{" "}</h3>
  
</div>

<div className="mt-3">
  <h3 className="d-inline">Return Date :-{" "}</h3>
  
</div>

<div className="mt-3">
  <h3 className="d-inline">Country :-{" "}</h3>
  
</div>

<div className="mt-3">
  <h3 className="d-inline">City :-{" "}</h3>
  
</div>

<div className="mt-3">
  <h3 className="d-inline">Hotel :-{" "}</h3>
  
</div>

<div className="mt-3">
  <h3 className="d-inline">Check-in :-{" "}</h3>
  
</div>

<div className="mt-3">
  <h3 className="d-inline">Check-out :-{" "}</h3>
  
</div>

<div className="mt-3">
  <h3 className="d-inline">No Of Nights :-{" "}</h3>
  
</div>

                   












</>

{/* working Refund */}
<>
  <h2 className="main-hading mt-4">Refund</h2>
  <hr/>

{/* Refund Quntity  */}
 <>
                      <label
                        htmlFor="  Actual No of Bed "
                        className="furas-input-label mt-3 mb-2"
                      >
                       Refund Quantity
                      </label>
                      <div className="row furas-dropdown1   px-2-1 mb-1">
                        <input
                          type="number"
                          name="Actual No of Bed"
                          id="refund_quantity"
                          value={mainState.refund_quantity|| ""} // ✅ from mainState
                          onChange={(e) =>
                            setMainState((prev) => ({
                              ...prev,
                              refund_quantity: e.target.value, // ✅ update this field only
                            }))
                          }
                          placeholder="Refund Quantity"
                        />
                        {errors?.refund_quantity && (
                          <p className="error-message red-color">
                            {errors?.refund_quantity}
                          </p>
                        )}
                      </div>
                    </>


{/* Remarks */}

<>
  <label
    htmlFor="refund_quantity"
    className="furas-input-label mt-3 mb-2"
  >
    Remarks
  </label>
  <div className="row  px-2-1 mb-4">
    <textarea
      name="refund_quantity"
      id="refund_quantity"
      value={mainState.Remarks || ""} // ✅ from mainState
      onChange={(e) =>
        setMainState((prev) => ({
          ...prev,
          Remarks: e.target.value, // ✅ update this field only
        }))
      }
      placeholder="Refund Quantity"
      className="furas-dropdownForTEXTArea "
      rows={3} // you can adjust height
    />
    {errors?.Remarks && (
      <p className="error-message red-color">
        {errors?.Remarks}
      </p>
    )}
  </div>
</>













</>

                

            

                    {/* submition  */}
                    <div
                      className="row furas-inputs pt-4"
                      style={{ marginBottom: "30px" }}
                    >
                      <button
                        type="submit"
                        className="submit-btn"
                        onClick={SubmitingFunction}
                      >
                        Submit
                      </button>
                      

                    </div>

                  </form>
                  
                 
                </div>
              </div>
            </MDBContainer>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ActualHotalReturnModal;
